/** @module MaterialSpec/ThemePromoteColorSpecForm **/
define([
		"dojo/_base/declare",
		"Apparel/_ColorMaterialFormMixin"
], function(declare,_ColorMaterialFormMixin) {

	return declare(_ColorMaterialFormMixin, {});
});